<template>
  <div class="hm-transfer">
    <div class="tree-wrapper flex" v-if="!isVouchers">
      <div v-show="!isCheckedAttribute">
        <span>选择品类</span>
        <el-scrollbar
          ref="scrollContainer"
          :vertical="false"
          wrap-style="height: 300px;"
        >
          <el-tree
            :disabled="disabled"
            empty-text="暂无品类"
            :props="props"
            :load="loadNode"
            node-key="attrId"
            ref="tree"
            highlight-current
            lazy
            show-checkbox
            @check-change="handleCheckChange"
          ></el-tree>
        </el-scrollbar>
      </div>
      <!-- <div v-if="showAttribute">
        <span>选择标签</span>
        <el-scrollbar
          ref="scrollContainer"
          :vertical="false"
          wrap-style="height: 300px;"
        >
          <el-tree
            v-show="!brandId && !isChecked && !goodsName"
            empty-text="暂无标签"
            :props="attributeProps"
            :load="loadAttributeNode"
            node-key="attrId"
            ref="attributeTree"
            highlight-current
            lazy
            show-checkbox
            @check-change="handleCheckChangeAttribute"
          ></el-tree>
        </el-scrollbar>
      </div> -->
    </div>
    <div class="flex flex-between ">
      <div class="flex item-center">
        <el-select
          v-if="!isVouchers"
          size="small"
          clearable
          placeholder="选择品牌"
          v-model="brandId"
          class="mr10"
          filterable
          :disabled="isCheckedAttribute || disabled"
        >
          <el-option
            v-for="(item, i) in offlineBrandList"
            :key="i"
            :label="item.attrValue"
            :value="item.attrId"
          ></el-option>
        </el-select>

        <el-input
          :disabled="isCheckedAttribute || disabled"
          size="small"
          clearable
          class="mr10"
          style="width:235px"
          :placeholder="queryPlaceholder"
          v-model.trim="goodsName"
        >
          <el-select
            style="width:90px"
            v-model="goodsType"
            @change="goodsTypeChange"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option label="按货号" value="goodsSn"></el-option>
            <el-option
              label="按条码"
              value="barcode"
              v-if="showBarcode"
            ></el-option>
          </el-select>
        </el-input>

        <el-button
          size="small"
          :disabled="disabled"
          @click="resetGoodsList"
          class="mr10 hmicon icon-zhongzhi"
        ></el-button>
        <el-button
          size="small"
          type="primary"
          @click="queryGoodsList"
          :disabled="
            (!brandId &&
              !isChecked &&
              !goodsName &&
              showAttribute &&
              !isCheckedAttribute) ||
              disabled
          "
          >查询</el-button
        >
      </div>
      <!-- <div class="flex flex-wrap" v-if="!disabled">
        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入商品({{ goodsType === "goodsSn" ? "按货号" : "按条码" }})
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div> -->
    </div>
    <div class="flex item-center">
      <!-- 左边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
          </div>
          <div class="transfer-title flex-2 text-center">待选商品</div>
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 num">货号/条码/编号</div>
          <!-- <div class="flex-1 num" >商品条码</div> -->
          <div class="flex-1 name text-center">名称</div>
        </div>
        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              :disabled="disabled"
              v-model="leftChecked"
              @change="handleLeftCheckedChange"
            >
              <div
                v-for="(v, i) in leftData"
                :key="i"
                class="check-wrapper flex item-center"
                :title="v.attrValue"
              >
                <div class="flex-3">
                  <el-checkbox :label="v" class="flex">
                    <!-- :content="
                        v.attrType === 'barcode'
                          ? `条码：${v.barcode}`
                          : `货号/编号：${v.attrId}`
                      " -->
                    <el-tooltip
                      :content="`${v.tip}：${v.attrId}`"
                      placement="top"
                    >
                      <!-- <span class="flex-1 attrid">{{
                        v.attrType === "barcode"
                          ? `条码：${v.barcode}`
                          : `货号/编号：${v.attrId}`
                      }}</span> -->
                      <span class="flex-1 attrid">
                        {{ `${v.tip}：${v.attrId}` }}
                      </span>
                    </el-tooltip>
                    <!-- <el-tooltip :content="v.barcode" placement="top" >
                      <span class="flex-1 goods-name text-center">{{ v.barcode }}</span>
                    </el-tooltip> -->
                    <el-tooltip :content="v.attrValue" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.attrValue
                      }}</span>
                    </el-tooltip>
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="flex flex-column control text-center">
        <div class="mb20">操作</div>
        <!-- <el-switch
          v-model="isMustDelivery"
          v-if="showMustDelivery"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="yes"
          active-text="必选"
          inactive-text="可选"
          inactive-value="no"
        >
        </el-switch> -->
        <!-- <el-switch
          size="mini"
          class="transfer-switch"
          v-if="showUseable"
          v-model="whitelistState"
          :disabled="disabled"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch> -->
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0 || disabled"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="
            leftData.length <= 0 || leftChecked.length <= 0 || disabled
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0 || disabled"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="
            rightData.length <= 0 || rightChecked.length <= 0 || disabled
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou delete-selected"
          @click="deleteChecked"
          :disabled="
            leftChecked.length <= 0 || rightData.length <= 0 || disabled
          "
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button>
      </div>
      <!-- 右边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="rightData.length <= 0 || disabled"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
          </div>
          <div class="transfer-title flex-2 text-center">已选商品</div>
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 num">货号/条码/编号</div>
          <div class="flex-2 name text-center">名称</div>
        </div>
        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="rightChecked"
              @change="handleRightCheckedChange"
              :disabled="disabled"
            >
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper   item-center"
              >
                <div class="flex">
                  <el-checkbox :label="v" class="flex flex-3 item-center">
                    <!-- <el-tooltip
                      :content="
                        v.attrType === 'barcode'
                          ? `条码：${v.barcode}`
                          : `货号/编号：${v.attrId}`
                      "
                      placement="top"
                    >
                      <span class="flex-1 attrid">{{
                        v.attrType === "barcode"
                          ? `条码：${v.barcode}`
                          : `货号/编号：${v.attrId}`
                      }}</span>
                    </el-tooltip> -->
                    <el-tooltip
                      :content="`${v.tip}：${v.attrId}`"
                      placement="top"
                    >
                      <!-- <span class="flex-1 attrid">{{
                        v.attrType === "barcode"
                          ? `条码：${v.barcode}`
                          : `货号/编号：${v.attrId}`
                      }}</span> -->
                      <span class="flex-1 attrid">
                        {{ `${v.tip}：${v.attrId}` }}
                      </span>
                    </el-tooltip>
                    <el-tooltip :content="v.attrValue" placement="top">
                      <span
                        class="flex-2  goods-name  flex flex-center item-center text-overflow"
                        >{{ v.attrValue }}</span
                      >
                    </el-tooltip>
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            prop="goodsSn"
            :label="goodsType === 'goodsSn' ? '错误货号' : '错误条码'"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  props: {
    showBarcode: {
      type: Boolean,
      default: false
    },
    showUseable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isVouchers: {
      type: Boolean,
      default: false
    },
    showAttribute: {
      type: Boolean,
      default: false
    },
    onlySelectGoods: {
      type: Boolean,
      default: false
    },
    showMustDelivery: {
      type: Boolean,
      default: false
    },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    queryIsUsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      queryPlaceholder: "商品关键字/货号",
      goodsType: "goodsSn",
      errInputResult: [],
      errValidGoods: false,
      whitelistState: "white",
      isCheckedAttribute: false,
      isMustDelivery: false,
      catId: "",
      brandId: "",
      goodsName: "",
      categoryList: [],
      brandList: [],
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: "",
      isChecked: false,
      props: {
        value: "id",
        label: "name",
        children: "children",
        isLeaf: "leaf"
      },
      attributeProps: {
        value: "attrId",
        label: "attrValue",
        children: "children",
        isLeaf: "leaf"
      }
    };
  },
  computed: mapGetters([
    "offlineGoodsListResult",
    "offlineBrandList",
    "crossQueryResult",
    "goodsByBarcode"
  ]),
  watch: {
    showUseable(val) {
      if (val) {
        this.whitelistState = "white";
      }
    },
    goodsByBarcode(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    crossQueryResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    offlineGoodsListResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    leftOption(val) {
      this.leftData = val;
    },
    rightChecked(val) {
      if (this.rightName === "给下列导购发放优惠券") {
        this.$store.commit("queryIsEnable", val.length > 0);
      }
      this.$emit("checkGoods", val.length > 0);
    }
  },
  mounted() {
    this.$store.dispatch("queryOfflineBrandList");
  },
  methods: {
    goodsTypeChange(val) {
      if (val === "goodsSn") {
        this.queryPlaceholder = "商品关键字/货号";
      } else if (val === "barcode") {
        this.queryPlaceholder = "商品条码";
      }
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader =
          this.goodsType === "goodsSn"
            ? ["商品货号(单次最多导入200条)"]
            : ["商品条码(单次最多导入200条)"];
        const data = [["ABC123 "]];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let isValid = true;
        // let isRequired = true;
        let goodsSns = [];
        result.forEach(v => {
          v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
          if (v[0] !== "") {
            formatResult.push({
              goodsSn: v[0]
            });
          }
        });
        formatResult = arrayUnique2(formatResult, "goodsSn");
        goodsSns = formatResult.map(o => o.goodsSn);
        let importType = that.goodsType === "goodsSn" ? "goods" : "barcode";
        that.$store
          .dispatch("queryGoodsSnOffline", { goodsSns, importType })
          .then(res => {
            const { code, result } = res;
            if (code === "0") {
              if (result.notEffectiveGoods.length) {
                that.errValidGoods = true;
                that.errInputResult = result.notEffectiveGoods;
                that.$message({
                  message: `部分${
                    that.goodsType === "goodsSn" ? "货号" : "条码"
                  }货号导入失败！`,
                  type: "warning"
                });
              }
              if (that.goodsType === "goodsSn") {
                result.effectiveGoods.forEach(v => {
                  v.attrValue = v.goodsName;
                  v.attrId = v.goodsSn;
                  v.attrType = "goods";
                  v.tip = "货号";
                });
              } else if (that.goodsType === "barcode") {
                result.effectiveGoods.forEach(v => {
                  v.attrValue = v.goodsName;
                  v.attrId = v.barcode;
                  v.attrType = "barcode";
                  v.tip = "条码";
                });
              }

              that.leftData.push(...result.effectiveGoods);
              that.leftData = arrayUnique2(that.leftData, "attrId");
              that.leftData.forEach(v => {
                if (v.goodsName) {
                  v.goodsInfo = v.goodsName;
                }
              });
            }
          });
        // result.forEach(v => {
        //   if (!v[0] || !v[1] || !v[2]) {
        //     isRequired = false;
        //   } else {
        //     if (!that.isString(v[1]) || !that.isString(v[2])) {
        //       isValid = false;
        //       //   that.errValidGoods = true;
        //       //   that.errInputResult.push({
        //       //     name: v[0],
        //       //     mobile: v[1]
        //       //   });
        //     } else {
        //       goodsSns.push(v[0]);
        //       formatResult.push({
        //         goodsSn: (v[0] + "").replace(/ /g, ""),
        //         commissionStartTime: `${v[1]} 00:00:00`,
        //         commissionEndTime: `${v[2]} 23:59:59`,
        //         commissionType:
        //           v[3] === "固定返佣" ? "fixedReturn" : "ratioReturn",
        //         commissionValue: v[4] ? v[4] : "",
        //         agentDiscountValue: v[5] ? v[5] : ""
        //       });
        //     }
        //   }
        // });
        // if (isValid && isRequired) {
        //   let errList = formatResult.filter((item, index, self) => {
        //     for (let i = index + 1; i < self.length; i++) {
        //       if (self[i].goodsSn === item.goodsSn) {
        //         return true;
        //       }
        //     }
        //     return false;
        //   });

        //   if (errList.length > 0) {
        //     that.errValidGoods = true;
        //     that.errInputResult = errList;
        //     that.$message({
        //       message: "导入失败，有重复商品货号！",
        //       type: "warning"
        //     });
        //   } else {
        //     that.$store
        //       .dispatch("queryShareGoodsSn", { goodsSns })
        //       .then(res => {
        //         const { code, result } = res;
        //         if (code === "0") {
        //           if (result.resultList.length > 0) {
        //             that.distributionGoodList = [];
        //             result.resultList.forEach(v => {
        //               formatResult.forEach(item => {
        //                 if (v.goodsSn === item.goodsSn) {
        //                   that.distributionGoodList.push(
        //                     Object.assign({}, item, v)
        //                   );
        //                 }
        //               });
        //             });
        //           }
        //           if (result.errGoodsSns.length > 0) {
        //             that.errValidGoods = true;
        //             that.errInputResult = [];
        //             result.errGoodsSns.forEach(v => {
        //               that.errInputResult.push({ goodsSn: v });
        //             });
        //           }
        //         }
        //       });
        //   }
        // } else {
        //   if (!isRequired) {
        //     that.$message({
        //       message: "导入失败，请导入必填商品信息！",
        //       type: "warning"
        //     });
        //   } else if (!isValid) {
        //     that.$message({
        //       message: "导入失败，日期请使用文本格式导入！",
        //       type: "warning"
        //     });
        //   }
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    filterInteger(value, i) {
      if (value.length == 1) {
        this.rightData[i].goodsPackageNum = value.replace(/[^1-9]/g, "");
      } else {
        this.rightData[i].goodsPackageNum = value.replace(/\D/g, "");
      }
      this.$forceUpdate();
    },
    queryGoodsList() {
      const checkCateGoryList = this.$refs.tree
        ? this.$refs.tree.getCheckedNodes()
        : [];
      if (
        this.onlySelectGoods &&
        !this.isCheckedAttribute &&
        !this.isVouchers
      ) {
        // 交叉查询
        const offlineId = [];
        if (checkCateGoryList.length) {
          checkCateGoryList.forEach(v => {
            offlineId.push(v.attrId);
          });
        }
        if (this.goodsType === "goodsSn") {
          this.$store.dispatch("queryOfflineGoodsListResult", {
            goodsName: this.goodsName,
            brandId: this.brandId,
            offlineId
          });
        } else if (this.goodsType === "barcode") {
          this.$store.dispatch("queryGoodsByBarcode", {
            barcode: this.goodsName,
            brandId: this.brandId,
            offlineId
          });
        }
      } else {
        if (this.isChecked && !this.brandId && !this.goodsName) {
          // 只查品类
          this.leftData = checkCateGoryList || [];
        } else if (!this.isChecked && this.brandId && !this.goodsName) {
          // 只查品牌
          this.leftData =
            this.offlineBrandList.filter(v => v.attrId === this.brandId) || [];
        } else if (!this.isChecked && !this.brandId && this.goodsName) {
          // 只查商品
          if (this.goodsType === "goodsSn") {
            this.$store.dispatch("queryOfflineGoodsListResult", {
              goodsName: this.goodsName
            });
          } else if (this.goodsType === "barcode") {
            this.$store.dispatch("queryGoodsByBarcode", {
              barcode: this.goodsName
            });
          }
        } else if (this.isCheckedAttribute) {
          // 只查标签
          const attributeList = this.$refs.attributeTree.getCheckedNodes();
          this.leftData =
            attributeList.filter(o => o.attrType === "attribute") || [];
        } else {
          // 交叉查询
          const offlineId = [];
          if (checkCateGoryList.length) {
            checkCateGoryList.forEach(v => {
              offlineId.push(v.attrId);
            });
          }
          this.$store.dispatch("crossQueryGoods", {
            goodsName: this.goodsName,
            brandId: this.brandId,
            offlineId
          });
        }
      }
    },
    resetGoodsList() {
      this.$refs.tree.setCheckedNodes([]);
      this.brandId = "";
      this.goodsName = "";
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftData
          //     })
          //     .then(res => {
          //       if (this.leftData.length > 0) {
          //         this.rightData = this.rightData.concat(res.result);
          //         this.rightData.forEach(v => {
          //           v.activityName = v.existActivity
          //             ? v.existActivity.map(item => item.promotionName)
          //             : [];
          //           v.activityStr = v.activityName.join(",");
          //           if (this.isMustDelivery) {
          //             v.isMustDelivery = this.isMustDelivery;
          //           }
          //         });
          //         this.leftData = [];
          //         this.leftChecked = [];
          //       }
          //       this.handleRightCheckAllChange(true);
          //       this.leftCheckAll = false;
          //       this.rightCheckAll = true;
          //     });
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
    },
    toRight() {
      // 移动选中到右边

      const result = this.checkCommon(this.leftChecked, this.rightData);

      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }

        if (this.queryIsUsed) {
          // this.rightData = this.leftData;
          this.rightData = this.rightData.concat(this.leftChecked);
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          // this.leftData = [];
          // this.leftChecked = [];
          // this.handleRightCheckAllChange(true);
          // this.leftCheckAll = false;
          // this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftChecked
          //     })
          //     .then(res => {
          //       this.rightData = this.rightData.concat(res.result);
          //       this.rightData.forEach(v => {
          //         v.activityName = v.existActivity
          //           ? v.existActivity.map(item => item.promotionName)
          //           : [];
          //         v.activityStr = v.activityName.join(",");
          //         if (this.isMustDelivery) {
          //           v.isMustDelivery = this.isMustDelivery;
          //         }
          //       });
          //       this.leftChecked = [];
          //       this.leftIsIndeterminate = false;
          //       this.leftCheckAll = false;
          //       this.handleRightCheckAllChange(true);
          //       this.rightCheckAll = true;
          //     });
        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          this.rightData.forEach(v => {
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v.attrId === this.leftChecked[0].attrId) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v.attrId === item.attrId) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);
      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (v.attrId === this.rightChecked[0].attrId) {
              this.rightData.splice(i, 1);
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (v.attrId === item.attrId) {
                this.rightData.splice(index, 1);
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.attrId) === String(item.attrId)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
    },
    handleCheckChangeAttribute() {
      this.isCheckedAttribute =
        this.$refs.attributeTree.getCheckedNodes().length > 0;
    },
    loadNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    loadAttributeNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestAttributeTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getAttributeIndex(node, resolve);
      }
    },
    // 首次加载属性数
    requestAttributeTree(resolve) {
      this.$store
        .dispatch("queryAttrListByAddGoods")
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.valueId;
            v.attrValue = v.attributeValue;
            v.attrType = "attribute";
            v.disabled = true;
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 首次加载一级节点数据函数
    requestTree(resolve) {
      this.$store
        .dispatch("queryOfflineCategoryList", {
          level: 0,
          offlineId: ""
        })
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.id;
            v.attrValue = v.name;
            v.attrType = "category";
            v.disabled = this.disabled;
            v.tip = "品类";
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      this.$store
        .dispatch("queryOfflineCategoryList", {
          offlineId: node.data.id,
          level: node.level
        })
        .then(res => {
          const data = res.result;

          data.forEach(v => {
            v.attrId = v.id;
            v.attrValue = v.name;
            v.attrType = "category";
            v.disabled = this.disabled;
            v.tip = "品类";
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    getAttributeIndex(node, resolve) {
      //   if (node.level > 1) return resolve([]);
      let params = {};
      if (node.level === 1) {
        params = {
          typeId: node.data.valueId
        };
      } else {
        params = {
          attributeId: node.data.valueId
        };
      }
      this.$store
        .dispatch("queryAttrListByAddGoods", params)
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.valueId;
            v.attrValue = v.attributeValue;
            v.attrType = "attribute";
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }
};
</script>
<style lang="scss">
.hm-transfer {
  padding: 10px;
  .table-body {
    .check-wrapper {
      padding-left: 12px;
    }
    .el-checkbox {
      width: 100%;
    }

    .el-checkbox__label {
      width: calc(100% - 24px);
      display: flex;
    }
    .check-wrapper:nth-child(even) {
      background: #f7f7f7;
    }
  }
  .el-checkbox {
    margin-right: 0;
  }
}
</style>

<style lang="scss" scoped>
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  max-width: 500px;
  width: 490px;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      margin-left: 26px;
    }
    .name {
      margin-left: -26px;
    }
  }
  .table-body {
    font-size: 12px;

    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
  .goods-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    box-sizing: border-box;
    width: 100px;
  }
}

.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 274px;
}
</style>
